// @ts-nocheck
import * as React from "react";

const EditFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M5 19h1.098L16.796 8.302l-1.098-1.098L5 17.902V19Zm-1 1v-2.52L17.875 3.58l2.54 2.563L6.52 20H4ZM16.238 7.762l-.54-.558 1.098 1.098-.558-.54Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(EditFill);
